/**
 * Created by RKL on 07/09/2015.
 */
define('sampleDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'sampleDetailsView',
  'emptyView',
  'sampleDetailTabController',
  'smpResListTabController',
  'rolesMixin',
  'settings',
  'samplesTabs',
  'entities/samples'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  sampleDetailTabController,
  smpResListTabController
) {
  'use strict';

  var SamplesDetailsController = {
    fetchSample: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showSample(data);
      } else {
        this.model = App.request('sample:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showSample(data);
          }
        });
      }
    },

    showSample: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'sample:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (sample) {
      this.view.onHeaderChange(sample);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          case 'smpres':
            smpResListTabController.showSmpResList(data);
            break;
          default:
            sampleDetailTabController.showTab(data);
            break;
        }
      } else {
        sampleDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('samples/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = SamplesDetailsController;
});
